import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { completeEndpoint, EndpointPart } from '../../core/global';
import { TableViewCustomModel } from '../../sub-component/table-view-administration/tva-custom/common/model/table-view-custom-model';
import { EndpointService } from '../endpoint/endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class TableViewService {
  private readonly http = inject(HttpClient);
  private readonly endpointService = inject(EndpointService);

  public saveTableView(tableViewModel: TableViewCustomModel): Observable<TableViewCustomModel[]> {
    const endpointUrl = completeEndpoint(EndpointPart.POST_TABLE_VIEW_REGISTERED_USER);
    const url: string = this.endpointService.getEndpointUrl(endpointUrl);

    return this.http.post<TableViewCustomModel[]>(url, tableViewModel);
  }

  public updateTableView(tableViewModel: TableViewCustomModel): Observable<TableViewCustomModel[]> {
    const endpointUrl = completeEndpoint(EndpointPart.PUT_TABLE_VIEW_REGISTERED_USER);
    const url: string = this.endpointService.getEndpointUrl(endpointUrl);

    return this.http.put<TableViewCustomModel[]>(url, tableViewModel);
  }

  public getTableViewsFromRegisteredUserByTableViewArea(tableViewArea: string): Observable<TableViewCustomModel[]> {
    const pathParams: Map<string, string> = new Map();
    pathParams.set('tableViewArea', tableViewArea);
    const endpointUrl = completeEndpoint(EndpointPart.GET_TABLE_VIEW_REGISTERED_USER);
    const url: string = this.endpointService.getEndpointUrl(endpointUrl, pathParams);

    return this.http.get<TableViewCustomModel[]>(url);
  }

  public deleteTableView(tableViewModel: TableViewCustomModel): Observable<TableViewCustomModel[]> {
    const endpointUrl = completeEndpoint(EndpointPart.DELETE_TABLE_VIEW_REGISTERED_USER);
    const pathParams: Map<string, number> = new Map();
    pathParams.set('tableViewId', tableViewModel.id);
    const url: string = this.endpointService.getEndpointUrl(endpointUrl, pathParams);

    return this.http.delete<TableViewCustomModel[]>(url);
  }
}
